import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { XMLHttpRequestInterceptor } from './xmlhttprequest.interceptor';
import { MsalInterceptor } from '@azure/msal-angular';

export const httpInterceptorProviders = [];
